import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ImageService {
  rawImages: any = {}; // Image file and name
  croppedImages: any = {}; // Image SRC and name

  imageCropped: Subject<{ name: string, image: string }> = new Subject<{ name: string, image: string }>();
  imageSelected: Subject<{ name: string, image: HTMLImageElement }> = new Subject<{ name: string, image: HTMLImageElement }>();

  constructor() { }

  setImageToBeCropped(image: HTMLImageElement, name: string, originalFileName?: string) {
    this.rawImages[name] = {
      image: image
    };
    if (originalFileName) this.rawImages[name].originalFileName = originalFileName;
    this.imageSelected.next({ name: name, image: image });
  }

  setImageURLToBeCropped(url: string, name: string) {
    let originalFileName = url.split('/').pop();
    let img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url + '?timestamp=' + Date.now();
    this.setImageToBeCropped(img, name, originalFileName);
  }

  getImageToCrop(name: string): HTMLImageElement {
    if (this.rawImages[name]) return this.rawImages[name].image;
  }

  setCroppedImage(canvas: HTMLCanvasElement, name: string) {
    if (canvas) {
      let imageSrc = canvas.toDataURL('image/png');
      this.croppedImages[name] = imageSrc;
      this.imageCropped.next({ name: name, image: imageSrc });
    }
  }

  getCroppedImage(name: string): string {
    if (this.croppedImages[name]) return this.croppedImages[name];
  }

  getOriginalName(name: string) {
    if (this.rawImages[name]) return this.rawImages[name].originalFileName;
    return '';
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/image/image.service.ts